import { initialize } from 'redux-form'
import { FORM_NAME } from '../Form'

export default () => async (dispatch) => {

  dispatch(initialize(FORM_NAME, {
    type: 'invoice_single'
  }))

}